export default "__VITE_ASSET__Bb7Azxul__"